import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ui from 'domains/ui';
import textNodes from 'domains/text_nodes';

import { useAppDispatch } from 'utils/hooks';

import PassiveTextTools from './PassiveTextTools';

function TextToolSidebar() {
  const dispatch = useAppDispatch();

  function handleCloseButtonClick(e: React.MouseEvent) {
    e.preventDefault();
    dispatch(ui.actions.setSidebarComponent('default'));
    dispatch(textNodes.actions.setActiveTextNodeUid(''));
  }

  return (
    <div className="sidebar-wrapper sidebar-component texttools">
      <FontAwesomeIcon className="close" icon="times" onClick={handleCloseButtonClick} />
      <PassiveTextTools />
    </div>
  );
}

export default TextToolSidebar;
